module.exports = __webpack_public_path__ + "img/u23三人女篮初选.6d307e7b.png";